import React from 'react';
import { Icon } from '@gumtree/ui-library';

import {
    StyledLinkContainerStyle,
    StyledShowMoreContainerStyle,
} from './abbreviation-toggle.style';

const AbbreviationToggle = ({
    totalItemsSize,
    shortListLength,
    isDisplayShowLess,
    setIsShowFullList,
}: {
    totalItemsSize: number;
    shortListLength: number;
    isDisplayShowLess: boolean;
    setIsShowFullList: (newToggleState: boolean) => void;
}) => {
    if (totalItemsSize <= shortListLength) {
        return <></>;
    }

    return (
        <div css={StyledLinkContainerStyle}>
            <span
                role="button"
                tabIndex={0}
                css={StyledShowMoreContainerStyle}
                onClick={() => setIsShowFullList(!isDisplayShowLess)}
                onKeyDown={() => setIsShowFullList(!isDisplayShowLess)}
            >
                {isDisplayShowLess ? 'Show less' : `Show ${totalItemsSize - shortListLength} more`}

                <Icon
                    type={isDisplayShowLess ? 'chevron-u' : 'chevron-d'}
                    size="smallest"
                    className="chevron"
                />
            </span>
        </div>
    );
};

export default AbbreviationToggle;
